var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCasement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "casement",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 303.9 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M279.7,30.7L279.7,30.7L243,18.4c-0.7-0.3-1.5-0.2-2,0.3c-0.6,0.4-1,1.1-1,1.9v158.6c0,0.8,0.4,1.5,1,1.9 c0.4,0.3,0.8,0.4,1.3,0.4c0.3,0,0.5,0,0.7-0.1l36.8-12.3c0.9-0.3,1.6-1.2,1.6-2.2v-134C281.4,31.9,280.7,31,279.7,30.7z  M244.4,23.8l32.3,10.7v63.1h-32.3V23.8z M244.4,176.1v-73.8h32.3v63.1L244.4,176.1z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,169.1L25.5,169.1l36.8,12.3c0.2,0.1,0.5,0.2,0.7,0.1c0.5,0,0.9-0.1,1.3-0.4c0.6-0.4,1-1.1,1-1.9V20.6 c0-0.8-0.4-1.5-1-1.9c-0.6-0.4-1.4-0.6-2-0.3L25.5,30.7c-0.9,0.3-1.6,1.2-1.6,2.2v134C23.8,167.9,24.5,168.8,25.5,169.1z  M60.8,176.1l-32.3-10.7l0-63.1h32.3V176.1z M60.8,23.8v73.8H28.5l0-63.1L60.8,23.8z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M292.8,14.8h-31.9l-27.2-9.1c-0.7-0.3-1.5-0.2-2,0.3c-0.6,0.4-1,1.1-1,1.9v6.9H74.5V7.9c0-0.8-0.4-1.5-1-1.9 c-0.6-0.5-1.4-0.6-2-0.3l-27.2,9.1H13.5v4.5h16.9l-14.2,4.8c-1,0.3-1.6,1.2-1.6,2.2v147.4c0,1,0.7,1.8,1.6,2.2l14.2,4.8H13.5v4.6 h30.8l0.9,0.3l6.4,2.2l4.3,1.5l15.6,5.2c0.2,0.1,0.5,0.2,0.7,0.1c0.5,0,0.9-0.1,1.3-0.4c0.6-0.4,1-1.1,1-1.9v-7h156.1v7 c0,0.8,0.4,1.5,1,1.9c0.4,0.3,0.8,0.4,1.3,0.4c0.2,0,0.5,0,0.7-0.1l15.8-5.3l4.3-1.5l6.1-2.1l1-0.3h31.9v-4.6h-18l14.2-4.8 c1.3-0.7,1.6-1.3,1.6-2.2V26.2c0-0.5-0.2-1-0.6-1.4c-0.1-0.1-0.3-0.1-0.4-0.3c-0.2-0.2-0.4-0.3-0.6-0.4l-14.2-4.8h18V14.8z  M69.9,188.8l-14-4.7l-8.9-3l-27.8-9.3v-144l50.7-16.9V188.8z M74.5,28.6h13.7v142.7H74.5V28.6z M230.7,171.3h-13.7V28.6h13.7 V171.3z M230.7,23.9h-16.1c-1.3,0-2.3,1-2.3,2.3v147.4c0,1.3,1,2.3,2.3,2.3h16.1v4.6H74.5v-4.6h16.1c1.3,0,2.3-1,2.3-2.3V26.2 c0-1.3-1-2.3-2.3-2.3H74.5v-4.6h156.1V23.9z M286,28v144l-27.6,9.2l-8.9,2.9l-14.2,4.7V11.1L286,28z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.9,
    y: 16.1,
    width: 4.4,
    height: 168.3,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.1,
    y: 16.1,
    width: 4.4,
    height: 168.3,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 16.1,
    width: 4.4,
    height: 168.3,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 16.1,
    width: 4.4,
    height: 168.3,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 16.1,
    width: 4.4,
    height: 168.3,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 44.3,
    width: 79.8,
    height: 4.2,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 80.9,
    width: 79.8,
    height: 4.2,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 117.5,
    width: 79.8,
    height: 4.2,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 154.2,
    width: 79.8,
    height: 4.2,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,185.1h-8.5c-5.9,0-10.7-4.8-10.7-10.7V25.5c0-5.9,4.8-10.7,10.7-10.7h6.3v4.5h-6.3c-3.4,0-6.2,2.8-6.2,6.2v148.9 c0,3.4,2.8,6.2,6.2,6.2H21V185.1z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M291.8,185.1h-8.5v-4.5h8.5c3.4,0,6.2-2.8,6.2-6.2V25.5c0-3.4-2.8-6.2-6.2-6.2h-6.3v-4.5h6.3c5.9,0,10.7,4.8,10.7,10.7 v148.9C302.5,180.3,297.7,185.1,291.8,185.1z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasement);
export default __webpack_public_path__ + "static/media/casement.e8d61d1a3f96fd1281adc29c0a2f02b1.svg";
export { ForwardRef as ReactComponent };